import * as v from 'valibot';
import { createSlice } from '@reduxjs/toolkit';
import { isNumericIndexedObject } from '../types/util';
import { setDefinitions } from '../actions/SetDefinitions';
export const transmitterDeviceStateSchema = v.object({
    state: v.string(),
    ts: v.string(),
});
export function isTransmitterDeviceState(obj) {
    return (typeof obj === 'object' &&
        obj !== null &&
        'state' in obj && typeof obj.state === 'string' &&
        'ts' in obj && typeof obj.ts === 'string');
}
export const sensorDeviceStateSchema = v.object({
    battery: v.boolean(),
    humid: v.number(),
    temp: v.number(),
    ts: v.string(),
});
export function isSensorDeviceState(obj) {
    return (typeof obj === 'object' &&
        obj !== null &&
        'humid' in obj && typeof obj.humid === 'number' &&
        'humid' in obj && typeof obj.humid === 'number' &&
        'ts' in obj && typeof obj.ts === 'string');
}
// these are sent from the backend but not used in the frontend anymore
// so we just check if it's an object with numberic keys and then we
// don't care what the content is
export const zigbeeDeviceStateSchema = v.record(v.pipe(v.string(), v.digits()), v.unknown());
export function isZigbeeDeviceState(obj) {
    if (typeof obj !== 'object' || obj === null) {
        return false;
    }
    for (const key in obj) {
        if (!/^\d+$/.test(key)) {
            return false;
        }
    }
    return true;
}
export const deviceStateSchema = v.union([
    transmitterDeviceStateSchema,
    sensorDeviceStateSchema,
    zigbeeDeviceStateSchema
]);
export function isDeviceState(obj) {
    return isTransmitterDeviceState(obj) || isSensorDeviceState(obj) || isZigbeeDeviceState(obj);
}
export const deviceStatesSchema = v.record(v.pipe(v.string(), v.digits()), deviceStateSchema);
export function isDeviceStates(obj) {
    return isNumericIndexedObject(obj, isDeviceState);
}
function updateDeviceState(state, id, deviceState) {
    if (isTransmitterDeviceState(deviceState)) {
        state[id] = {
            ts: deviceState.ts,
            state: deviceState.state,
        };
    }
    else if (isSensorDeviceState(deviceState)) {
        state[id] = {
            ts: deviceState.ts,
            temp: deviceState.temp,
            humid: deviceState.humid,
            battery: deviceState.battery,
        };
    }
    // else it's a zigbee object
}
const initialState = {};
export const slice = createSlice({
    name: 'device_states',
    initialState,
    reducers: {
        updateDeviceStates(state, action) {
            for (const [id, actionstate] of Object.entries(action.payload)) {
                updateDeviceState(state, parseInt(id), actionstate);
            }
        }
    },
    extraReducers: builder => {
        builder
            .addCase(setDefinitions, (s, action) => {
            const newState = {};
            if (action.payload.device_states !== undefined) {
                for (const [id, actionstate] of Object.entries(action.payload.device_states)) {
                    updateDeviceState(newState, parseInt(id), actionstate);
                }
            }
            return newState;
        });
    },
});
export const { updateDeviceStates, } = slice.actions;
export const device_states = slice.reducer;
